<!--
 * @Author: your name
 * @Date: 2021-03-11 16:02:40
 * @LastEditTime: 2021-07-30 11:55:53
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \mooklook_phone\src\views\StarItem.vue
-->
<template>
  <div class="mook_introduce">
    <div class="introduce_details" :style="{ minHeight: height + 'px' }">
      <div class="introduce_title layout_level_center">{{ content.title }}</div>
      <div class="introduce_message">{{ content.description }}</div>
      <div
        v-if="content"
        class="introduce_content"
        v-html="content && content.articleContent"
      ></div>
      <div class="introduce_poster">
        <el-row :gutter="isPhone ? 10 : 40" v-if="seriesPoster.length <= 3">
          <el-col
            class="img"
            v-for="(item, index) in seriesPoster"
            :key="index"
            :span="
              index < seriesPoster.length - 1 && seriesPoster.length == 3
                ? 8
                : index < seriesPoster.length - 1 && seriesPoster.length == 2
                ? 12
                : 8
            "
          >
            <div class="grid-content bg-purple">
              <img class="auto-img" :src="item.imageUrl" />
            </div>
          </el-col>
        </el-row>
        <Poster v-else :ComponData="seriesPoster"></Poster>
      </div>
      <!-- 视频 -->
      <div
        v-if="
          video && video.length > 0 && this.playerOptions.sources[0].src != ''
        "
        class="vider_player flex_layout"
      >
        <video-player
          class="video-player vjs-custom-skin"
          ref="videoPlayer"
          :playsinline="true"
          :options="playerOptions"
        ></video-player>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
import { carouselByTitle, getArticleList } from "@/api/api";
import Footer from "../components/Footer";
import Poster from "../components/Poster";
export default {
  components: { Footer, Poster },
  // 定义属性
  data() {
    return {
      video: [],
      content: {
        articleContent: "",
      },
      height: 0,
      isPhone: document.body.clientWidth < 920,
      seriesPoster: [],
      // 视频播放
      playerOptions: {
        playbackRates: [0.5, 1.0, 1.5, 2.0], //可选择的播放速度
        autoplay: false, //如果true,浏览器准备好时开始回放。
        muted: false, // 默认情况下将会消除任何音频。
        loop: false, // 视频一结束就重新开始。
        preload: "auto", // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: "zh-CN",
        aspectRatio: "16:9", // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        sources: [
          {
            type: "",
            src: "", //url地址
          },
        ],
        poster: "", //你的封面地址
        notSupportedMessage: "此视频暂无法播放，请稍后再试", //允许覆盖Video.js无法播放媒体源时显示的默认信息。
        controlBar: {
          timeDivider: true, //当前时间和持续时间的分隔符
          durationDisplay: true, //显示持续时间
          remainingTimeDisplay: false, //是否显示剩余时间功能
          fullscreenToggle: false, //全屏按钮
        },
      },
    };
  },
  // 计算属性，会监听依赖属性值随之变化
  computed: {},
  // 监控data中的数据变化
  watch: {},
  // 方法集合
  methods: {
    getCarouselByTitle(type) {
      let title = type ? this.content.title : this.content.title + "(视频)";
      let params = {
        title: title || "",
      };
      carouselByTitle(params)
        .then((res) => {
          if (res.data.code == 0) {
            if (type) {
              this.seriesPoster = res.data.data;
            } else {
              this.video = res.data.data;

              if (this.video.length > 0)
                this.playerOptions.sources[0].src = this.video[0]
                  ? this.video[0].imageUrl
                  : "";
            }
          }
        })
        .catch((err) => {});
    },

    getArticleList(min = 1, max = 6) {
      let params = {
        articleTypeId: this.lange == "Ch" ? 42 : 45,
        pageIndex: min,
        pageSize: max,
      };
      getArticleList(params)
        .then((res) => {
          let index = this.$route.query.index.split("-");
          this.content =
            res.data.data.data.length > 0 ? res.data.data.data[index[1]] : null;
        })
        .catch((err) => {});
    },
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {
    if (this.$route.query.id) {
      this.articleId = this.$route.query.id;
      this.content = JSON.parse(this.$route.query.detail);
      this.getCarouselByTitle();
      this.getCarouselByTitle("poster");
      this.getArticleList();
    }
  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    let height = this.isPhone ? 233 : 427;
    this.height = window.screen.availHeight - height;
  },
  watch: {
    $route(to) {
      if (to.path == "/Introduce" && to.query.id) {
        this.articleId = to.query.id;
        this.content = JSON.parse(to.query.detail);

        this.getCarouselByTitle();
        this.getCarouselByTitle("poster");
        this.getArticleList();
      }
    },
  },
};
</script>

<style lang='less' scoped>
.poster {
  width: 100%;
  position: relative;
  .poster_img {
    cursor: pointer;
  }
}
.vider_player {
  margin-bottom: 60px;
  .play_button {
    width: 90px;
    height: 90px;
    border-radius: 50%;
    border: 1px solid #fff;
  }
  .button_bg {
    width: 100%;
    height: 100%;
    background: #fff;
    opacity: 0.1;
    border-radius: 50%;
  }
  .play_icon {
    width: 43px;
  }
}
.introduce {
  &_title {
    font-weight: blod;
    color: #3e3a39;
    display: inline-block;
  }

  &_message {
    color: #878787;
    text-align: center;
  }
}
</style>
